// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150929/js/" + chunkId + "." + {"44":"841b64e6","225":"ea4cacce","481":"fea0f467","486":"36333f45","770":"7e80089e"}[chunkId] + ".0.012969413733737833.chunk.js";
};